import { render, staticRenderFns } from "./detailTable14.vue?vue&type=template&id=226c50b1&scoped=true"
import script from "./detailTable14.vue?vue&type=script&lang=js"
export * from "./detailTable14.vue?vue&type=script&lang=js"
import style0 from "./detailTable14.vue?vue&type=style&index=0&id=226c50b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c50b1",
  null
  
)

export default component.exports